import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class EmigrantService {

    getList(token, filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const apiUrl = BACKEND_URL + "/api/patronage/my-emigrant-references/";
        return axios.get(apiUrl, config);
    };


    getCountries(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/country-emigrant/";
        return axios.get(apiUrl, config);
    };


    register(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        const apiUrl = BACKEND_URL + "/api/patronage/emigrant-reference/";
        return axios.post(apiUrl, data, config);
    };


    update(token, data, id) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        const apiUrl = BACKEND_URL + "/api/patronage/emigrant-reference/" + id + "/";
        return axios.put(apiUrl, data, config);
    };


    delete(token, id) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        const apiUrl = BACKEND_URL + "/api/patronage/emigrant-reference/" + id + "/";
        return axios.delete(apiUrl, config);
    };

}

export default new EmigrantService();